"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var index_1 = require("../../core/utils/index");

var SimulationBigNumber_1 = require("../model/SimulationBigNumber");

var SimulationBigNumberConverter_1 = require("./SimulationBigNumberConverter");
/**
 * Default implementation of SimulationBigNumberConverter.
 *
 * @author BPo
 */


var SimulationBigNumberConverterImpl =
/*#__PURE__*/
function (_SimulationBigNumberC) {
  _inherits(SimulationBigNumberConverterImpl, _SimulationBigNumberC);

  function SimulationBigNumberConverterImpl() {
    _classCallCheck(this, SimulationBigNumberConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimulationBigNumberConverterImpl).apply(this, arguments));
  }

  _createClass(SimulationBigNumberConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new SimulationBigNumber_1.SimulationBigNumber(SimulationBigNumber_1.SimulationBigNumber.schema.simulatedValue.valueOf(conversions.toBigNumber(source.simulatedValue)), SimulationBigNumber_1.SimulationBigNumber.schema.originalValue.valueOf(source.originalValue !== null ? conversions.toBigNumber(source.originalValue) : null), SimulationBigNumber_1.SimulationBigNumber.schema.note.valueOfField(source), SimulationBigNumber_1.SimulationBigNumber.schema.accepted.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        simulatedValue: conversions.fromBigNumber(source.simulatedValue),
        originalValue: index_1.Utils.isValueMissing(source.originalValue) ? null : conversions.fromBigNumber(source.originalValue),
        note: source.note,
        accepted: source.accepted
      });
      return result;
    }
  }]);

  return SimulationBigNumberConverterImpl;
}(SimulationBigNumberConverter_1.SimulationBigNumberConverter);

exports.SimulationBigNumberConverterImpl = SimulationBigNumberConverterImpl;